import { cartActionsStyles } from "@insite/content-library/Widgets/Cart/CartActions";
import { cartTotalStyles } from "@insite/content-library/Widgets/Cart/CartTotal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import get from "@insite/mobius/utilities/get";
import { css } from "styled-components";

cartActionsStyles.wideOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            margin-left: 20px;
            span {
                color: white !important;
            }
            ul {
                background: #ffffff;
            }
        `,
    },
};

cartActionsStyles.narrowOverflowMenu = {
    cssOverrides: {
        wrapper: css`
            span {
                color: white !important;
            }
            ul {
                background: #ffffff;
                > li {
                    > button {
                        text-align: unset;
                        border: 0px;
                        background: #ffffff;
                        span {
                            padding: 0px;
                            color: black !important;

                            font-weight: normal;
                        }
                    }
                }
            }
        `,
    },
};

cartActionsStyles.wideHidden = {
    below: "md",
    css: css`
        display: flex;
        justify-content: flex-end;
        button[data-test-selector^="cart_saveOrder"] {
            border: 1px solid rgb(204, 204, 204) !important;
            padding: 0px 18px !important;
            background: rgb(255, 255, 255) !important;
            > span {
                font-size: 12px;
                font-weight: 600;
                letter-spacing: 2px;
                line-height: 20px;
                text-align: center;
                color: rgb(0, 0, 0);
                text-transform: uppercase;
                &:hover {
                    color: rgb(0, 107, 192);
                }
            }
        }
    `,
};
